import { Pipe, PipeTransform } from '@angular/core';
import { KeywordHighlightModel } from '../../models/keyword-highlight.model';
import { HighlightPipe } from './highlight.pipe';

/**
* Takes a string and an array of strings, returns an HTML string with the array of strings highlighted in the original string
*/
@Pipe({
    name: 'highlightKeywords',
    standalone: false
})
export class HighlightKeywordsPipe implements PipeTransform {

    private cache: {[key: string]: RegExp};
    private readonly specialCharactersPattern: RegExp = /[\-\[\]\/\{\}\(\)\+\.\\\^\$\|]/g;

    constructor(
        private highlightPipe: HighlightPipe
    ) {
        this.cache = {};
    }

    /**
    * Wraps search strings found in text in wrapper provided by
    *
    * @param text             - Text to be searched and replaced inside
    * @param search           - Keywords Highlight models
    *
    * @returns string
    */
    transform(
        text: string,
        searches: KeywordHighlightModel[]
    ): string {
        if (!text || !searches || searches.length === 0) {
            return text;
        }

        let output = text;

        searches.forEach(search => {
            output = this.highlightPipe.transform(output, search.keywords, search.class, undefined, search.caseSensitive);
        });

        return output;
    }
}
